module.exports = __webpack_public_path__ + "img/hugh.f654b3ea.png";